import antdData from 'antd/lib/locale-provider/lv_LV';
import {createIntl, createIntlCache} from 'react-intl'
import 'moment/locale/lv'

const messages = {
    // TITLES
    'title.main': 'Galvenā',
    'title.news': 'Jaunumi',
    'title.legal': 'Juridiskā informācija',
    'title.partners': 'Mani partneri',
    'title.journal': 'Žurnāls',
    'title.finance': 'Finanses',
    'title.referral-links': 'Manas saites',
    'title.photobank': 'Fotobanka',
    'title.videobank': 'Videobanka',
    'title.files': 'Faili',
    'title.sales-report': 'Pārdošanas atskaites',
    'title.diagnostician-materials': 'Diagnostika',
    // MENU
    'menu.left.profile.available': 'Pieejams',
    'menu.left.profile.income': 'Gaidāmā izmaksa',
    'menu.left.profile.business-reputation': 'Biznesa Reputācija',
    'menu.left.profile.business-reputation-info-tooltip': 'Informācija par šo rādītāju',
    'menu.left.logout': 'Ienākt',
    'menu.left.goto-masterkit': 'Uz Master Kit',
    'menu.left.marketing-plan': 'Mārketinga plāns',
    'menu.left.support': 'Atbalsta dienests',
    'menu.left.useful-materials': 'Noderīgie materiāli',
    // DIAGNOSTICS
    'menu.left.diagnostics.title': 'Pārdotas diagnostikas',
    'menu.left.diagnostics.details.last7Days': ' 7 dienās',
    'menu.left.diagnostics.details.last30Days': '30 dienās',
    'menu.left.diagnostics.details.total': 'kopā',
    'menu.left.profileSnippet.diagnostics.top': 'TOP',
    // ACTIVATION
    'menu.left.profile.activation.title': 'Aktivizēšana',
    'menu.left.profile.activation.notExecuted': 'Nav izgatavots',
    'menu.left.profile.activation.daysLeft': '{daysLeft, plural, one {Atlikusi # diena} other {Atlikušas # dienas}}',
    'menu.left.profile.activation.expiresAt': 'Zaudē spēku \n{date}',
    // SETTINGS
    'settings.datetime.format': 'DD.MM.YYYY HH:mm',
    'components.locale-settings-modal.title': 'Izvēlieties valodu',
    'components.locale-settings-modal.change-confirm': 'Nomainīt valodu uz {language}?',
    'components.locale-settings-modal.change-confirm.yes': 'Jā',
    'components.locale-settings-modal.change-confirm.no': 'Atcelt',
    'components.legal-info.download-document': 'Lejuplādēt dokumentu',
    'locales.russian': 'krievu',
    'locales.english': 'angļu',
    'locales.bulgarian': 'bulgāru',
    'locales.french': 'franču',
    'locales.deutsch': 'vācu',
    'locales.hungarian': 'ungāru',
    'locales.italian': 'itāļu',
    'locales.kazakh': 'kazahu',
    'locales.latvian': 'latvju',
    'locales.spanish': 'spāņu',
    'locales.turkish': 'turku',
    // COMMON Components
    'components.profile-snippet.logout': 'Iziet no kabineta',
    'components.commissions-modal.title': 'Komisijas maksājuma specifikācija',
    'components.commissions-modal.table.user': 'No kā',
    'components.commissions-modal.table.level': 'Līmenis',
    'components.commissions-modal.table.date': 'Datums',
    'components.commissions-modal.table.product': 'Produkts',
    'components.commissions-modal.table.commission': 'Apjoms',
    'components.commissions-modal.table.percent': 'Procenti',
    'components.commissions-modal.table.amount': 'Summa',
    'components.commissions-modal.table.status': 'Status',
    'components.commissions-modal.table.user.external': 'Lietotājs var nebūt Jūsu struktūrā',
    'components.cookies-policy-agreement.text': 'Lietojot mūsu vietni, Jūs apstipriniet, ka esat izlasījis un sapratis sīkdatņu politiku, konfidencialitātes politiku un lietotāja vienošanos.',
    'components.cookies-policy-agreement.agree-button': 'Piekrītu',
    'components.cookies-policy-agreement.docs-link-text': 'Iepazīties ar informāciju',
    'components.commissions-modal.status.active': 'Procesā',
    'components.commissions-modal.status.rejected': 'Noraidīts',
    'components.commissions-modal.status.paid_out': 'Izpildīts',
    'components.rich-progress-bar.percentage-of-completion': 'Izpildīts uz {percent}%',
    'components.card-select.add-new': 'Pievienojiet jaunu karti',
    'components.remove-card.tooltip': 'Noņemiet kredītkarti',
    'components.remove-card.success-message': 'Kredītkarte ir veiksmīgi izdzēsta',
    'components.remove-card.confirmation-text': 'Vai noņemt kredītkarti?',
    'components.remove-card.warning-text': 'Visas nepabeigtās darbības,\nkas saistītas ar šo karti, tiks atceltas',
    'components.remove-card.yes': 'Jā',
    'components.remove-card.cancel': 'Atcelt',
    // COMMON Components - error-boundary
    'components.error-boundary.title': 'Modulī notika kļūda',
    'components.error-boundary.message-sent': 'Ziņa par to ir nosūtīta atbalstam un mēs to drīz novērsīsim.',
    'components.error-boundary.you-can': 'Jūs varat',
    'components.error-boundary.re-login': 'Ienākt atkārtoti',
    'components.error-boundary.or': 'vai',
    'components.error-boundary.refresh-page': 'Atjaunot vietni',
    'components.error-boundary.solve-yourself': 'lai pamēģinātu atrisināt problēmu patstāvīgi.',
    // Notifications
    'notifications.empty': 'Jaunu ziņu nav',
    'notifications.notification.remittance.incoming.title': 'Ienākošais pārskaitījums {amount}',
    'notifications.notification.remittance.incoming.description': 'no {fullname}',
    'notifications.notification.remittance.outgoing.title': 'Izpildīts pārskaitījums {amount}',
    'notifications.notification.remittance.outgoing.description': 'lietotājam {fullname}',
    'notifications.notification.goal-report.income.title': 'Saņemta atskaite par mērķa izpildi',
    'notifications.notification.goal-report.income.description': 'Mērķis: gūt ienākumus',
    'notifications.notification.goal-report.qualification.title': 'Saņemta atskaite par mērķa izpildi',
    'notifications.notification.goal-report.qualification.description': 'Mērķis: iegūt statusu',
    'notifications.notification.withdrawal.title': 'Līdzekļu izņemšana',
    'notifications.notification.withdrawal.approved': 'Bankas operācija apstiprināta',
    'notifications.notification.withdrawal.rejected': 'Bankas operācija noraidīta',
    'notifications.notification.withdrawal.canceled': 'Bankas operācija atcelta',
    'notifications.notification.survey.title': 'Jums jāveic aptauja',
    'notifications.notification.diagnostician-certificate.granted': 'Вы прошли аттестацию\nТеперь вы можете проводить диагностику',
    'notifications.notification.diagnostician-certificate.revoked': 'Ваша аттестация отозвана\nВы больше не можете проводить диагностику',
    // QUALIFICATIONS
    'qualification.client': 'Klients',
    'qualification.intern': 'Māceklis',
    'qualification.partner': 'Partneris',
    'qualification.official_partner': 'Oficiālais partneris',
    'qualification.mentor': 'Meistars',
    'qualification.regional_mentor': 'Reģionālais meistars',
    'qualification.international_mentor': 'Starptautiskais meistars',
    'qualification.top_leader': 'Top līderis',
    'qualification.shareholder': 'Akcionārs',
    'qualification.business_mentor': 'Meistars',
    'qualification.lead_shareholder': 'Vadošais akcionārs',
    'qualification.regional_mentor_first_month': 'Reģionālais meistars (1 mēnesis)',
    'qualification.shareholder_first_month': 'Akcionārs (1.mēnesis)',
    'qualification.shareholder_second_month': 'Akcionārs (2.mēnesis)',
    'qualification.top_leader_first_month': 'Top līderis (1.mēnesis)',
    'qualification.top_leader_second_month': 'Top līderis (2.mēnesis)',
    'qualification.international_mentor_first_month': 'Starptautiskais meistars (1.mēnesis)',
    'qualification.curator': 'Куратор',
    'qualification.organizer': 'Организатор',
    'qualification.practitioner': 'Игро-Практик',
    'qualification.community_ambassador': 'Амбассадор сообщества',
    'qualification.brend_ambassador': 'Амбассадор бренда',
    'qualification.company_ambassador': 'Амбассадор Компании',
    // LOGIN PAGE
    'page.login.title': 'Ienākt',
    'page.login.login': 'Lietotājvārds',
    'page.login.phone': 'Tālrunis',
    'page.login.by-login': 'Ienākt ar lietotājvārdu',
    'page.login.by-phone': 'Ienākt ar tālruņa numuru',
    'page.login.password': 'Parole',
    'page.login.login-required': 'Norādiet lietotājvārdu',
    'page.login.phone-required': 'Ievadiet tālruņa numuru',
    'page.login.password-required': 'Ierakstiet paroli',
    'page.login.submit-text': 'Ienākt',
    // 'page.login.error': 'Ошибка',
    'page.login.auth-wrong-pass-or-login-text': 'Nepareizi ievadīts lietotājvārds vai parole',
    'page.login.auth-wrong-pass-or-phone-text': 'Nepareizi ievadīts tālruņa numurs vai parole',
    'page.login.auth-error-text': 'Kļūda autorizējoties',
    // Verification
    'verification.title': 'Darba sākums',
    'verification.step-0.welcome': 'Laipni lūgti Super Ego Bizness',
    'verification.step-0.3-steps': 'Pirms mēs uzsākam darbu, Jums ir jāizpilda 3 soļi',
    'verification.step-0.start': 'Sākt',
    'verification.step-1.title': 'Solis 1',
    'verification.step-1.agreement.heading': 'Vienošanās',
    'verification.step-1.agreement.description': 'Visas attiecības starp kompāniju Super Ego un partneriem tiek regulētas ar savstarpējo Vienošanos. Lai turpinātu, ir jāiepazīstas un jāpieņem Vienošanās noteikumi.',
    'verification.step-1.agreement.text': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Facilisi natoque arcu purus urna, fermentum aliquam habitant nec mollis. Gravida fusce enim, sapien vitae. Volutpat sed in tellus condimentum dignissim risus. Felis, ultricies turpis sollicitudin arcu tellus quis est. Convallis fringilla lectus turpis commodo tincidunt sit commodo. Morbi amet volutpat nam elementum pellentesque semper. Neque commodo sagittis in mi nibh in. Dolor donec molestie nibh pellentesque. Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    'verification.step-1.i-agree': 'Es pieņemu Vienošanās noteikumus',
    'verification.step-1.download-pdf': 'Lejuplādēt PDF failu',
    'verification.step-1.next': 'Tālāk',
    'verification.step-2.title': 'Solis 2',
    'verification.step-2.living-city': 'Dzīvesvieta (pilsēta)',
    'verification.step-2.city-select-text': 'Lūdzu atlasiet no saraksta Jūsu dzīvesvietu (pilsētu)',
    'verification.step-2.type-living-city': 'Ierakstiet dzīvesvietu (pilsētu)',
    'verification.step-2.next': 'Tālāk',
    'verification.step-2.living-country': 'Dzīvesvietas valsts',
    'verification.step-2.your-living-country-is': 'Jūs dzīvojiet valstī:',
    'verification.step-2.citezenship-question': 'Jūs esat šīs valsts pilsonis un Jūsu dokumenti ir izdoti šajā valstī?',
    'verification.step-2.yes': 'Jā',
    'verification.step-2.no': 'Nē',
    'verification.step-2.citezenship': 'Pilsonība',
    'verification.step-2.citezenship-select-desc': 'Ja jūsu dokumenti ir izdoti citā valstī, lūdzu, norādiet kuras valsts rezidents jūs esat',
    'verification.step-2.type-citezensip': 'Ierakstiet Jūsu dzīvesvietas valsti',
    'verification.step-3.title': 'Solis 3',
    'verification.step-3.docs-upload': 'Dokumentu augšuplāde',
    'verification.step-3.docs-upload-desc': 'Lai oficiāli noformētu mūsu partnerattiecības, augšuplādējiet sekojošus dokumentus:',
    'verification.step-3.photos-note': 'Lai pārbaude notiktu viegli, pārliecinieties, ka Jūsu seja un pases dati ir skaidri saskatāmi fotogrāfijās.',
    'verification.step-3.docs-uploading': 'Vajadzīgo dokumentu saraksta augšuplāde...',
    'verification.step-3.docs-upload-server-error': 'Notika kļūda nosūtot dokumentus uz serveri',
    'verification.step-3.i-agree': 'Es piekrītu manu personas datu apstrādei',
    'verification.step-3.done': 'Izdarīts',
    'verification.step-3.choose-doc': 'Izvēlēties foto',
    'verification.step-3.id-card': 'Pases fotogrāfija tuvumā',
    'verification.step-3.photo-with-id-card': 'Selfijs ar pasi',
    'verification.step-4.loading': 'Ielādēšana',
    'verification.step-4.your-docs-on-review': 'Jūsu dokumenti tiek pārbaudīti',
    'verification.step-4.verification-duration': 'Informācija tiek apstrādāta 1-2 dienas',
    'verification.step-4.description-1-line': 'Tiklīdz dokumenti būs pārbaudīti,',
    'verification.step-4.description-2-line': 'Jums būs pieejamas funkcijas Master Kit Bizness',
    'verification.step-4.verification-rejected': 'Verifikācija noraidīta',
    'verification.step-4.retry': 'Iziet verifikāciju vēlreiz',
    'verification.step-4.congrats': 'Apsveicam!',
    'verification.step-4.second-line-desc': 'Tagad varat uzsākt biznesu',
    'verification.step-4.time-to-set-first-target': 'Tagad vajadzigs izvirzīt Jūsu pirmo mērķi Super Ego Biznesā',
    'verification.step-4.set-target': 'Izvirzīt mērķi',
    'verification.step-4.skip-set-target': 'Izlaist',
    // CREATE GOAL
    'set-goal.title': 'Mērķu izvirzīšana',
    'set-goal.new-period-has-begun': 'Sākas jauns atskaites periods.',
    'set-goal.lets-set-goal': 'Izvirzam mērķi, uz kuru dosimies.',
    'set-goal.time-to-set-new-goal': 'Laiks izvirzīt jaunus mērķus!',
    'set-goal.set-goal-by-income': 'Izvirzīt mērķi ienākumiem',
    'set-goal.you-set-goal-by-income': 'Jūs izvirzāt mērķi ienākumiem',
    'set-goal.dont-set': 'Neizvirzīt mērķi šomēnes',
    'set-goal.set-goal-by-qualification': 'Vēlos jaunu statusu',
    'set-goal.you-set-goal-by-qualification': 'Jūs izvēlējāties mērķi statusam.',
    'set-goal.your-next-qualification': 'Jūsu nākošais statuss:',
    'set-goal.requerements.required-personal-sales': '{count, plural, one {# personīgā pārdošana} other {# personīgās pārdošanas}} Master Kit',
    'set-goal.requerements.required-income': 'Ienākumi no 2 līdz 5 līmenim',
    'set-goal.requerements.title': 'Prasības:',
    'set-goal.error-already-set': 'Jūs jau izvirzījāt mērķi tekošajam mēnesim',
    'set-goal.description': 'Sperot pirmos soļus biznesā, ir ļoti svarīgi uzstādīt konkrētus, izmērāmus un sasniedzamus mērķus. Mērķi Super Ego Business tiek uzstādīti katru mēnesi.',
    'set-goal.income-amount-question': 'Cik jūs gribat nopelnīt {monthAndYear} gadā?',
    'set-goal.amount-placeholder': 'Summa',
    'set-goal.by-income.prediction': 'Tas ir apmēram {sellsCount, plural, one {# pārdošana} other {# pārdošanas}} Master Kit (atkarībā no komplekta maksas)',
    'set-goal.income.you-will-get': 'No katras Master Kit pārdošanas jūs saņemsiet',
    'set-goal.submit': 'Izvirzīt mērķi',
    'set-goal.go-back': 'Atgriezties pie mērķa uzstādīšanas',
    'set-goal.skip': 'Turpināt bez mērķa',
    'set-goal.skip-confirm-question': 'Vai esat pārliecināts, ka vēlaties izlaist mērķa izvirzīšanas soli?',
    'set-goal.skip-confirm-description': 'Mērķa uzstādīšana palīdz Jums izsekot jūsu darbības efektivitāti un turēt fokusu',
    'set-goal.skip-finish.heading-line-1': 'Nekas, nekas',
    'set-goal.skip-finish.heading-line-2': 'Jūs varat uzstādīt mērķi vēlāk',
    'set-goal.skip-finish.welcome': 'Laipni lūgti Partnera kabinetā',
    'set-goal.skip-finish.go': 'Pāriet',
    'set-goal.success.great': 'Lieliski!',
    'set-goal.success.goal-set': 'Mērķis ir izvirzīts',
    'set-goal.success.welcome': 'Laipni lūgti Partnera kabinetā',
    'set-goal.success.go': 'Pāriet',
    // GOAL REPORT
    'goal-report.title': 'Atskaite par {monthYear}',
    'goal-report.not-found': 'Atskaite nav atrasta',
    'goal-report.period-finished': 'Atkaites periods ir beidzies. Zemāk ir pārskats par Jūsu mērķi.',
    'goal-report.your-goal': 'Jūsu mērķis:',
    'goal-report.your-goal.get-income': 'Saņemt ienākumus {amount}',
    'goal-report.your-goal.get-qualification': 'Iegūt statusu "{expQualification}"',
    'goal-report.your-goal.qualification.current-result.required-personal-sales': 'Personīgās pārdošanas:{currentValue} no {required}',
    'goal-report.your-goal.qualification.current-result.required-income': 'Ienākumi no 2.līdz 5.līmenim: {currentValue} no {required}',
    'goal-report.result.created': 'Mērķis vēl netika sasniegts',
    'goal-report.result.unperformed': 'Diemžēl, Jūs nesasniedzāt mērķi',
    'goal-report.result.performed': 'Apsveicam! Jūs veiksmīgi sasniedzāt mērķi',
    'goal-report.earnings': 'Jūs nopelnījāt {amount}',
    'goal-report.show-income-details': 'Parādīt ienākumu detaļas',
    'goal-report.go-next': 'Tālāk',
    'goal-report.go-home-page': 'Uz galveno',
    // FOOTER
    'footer.rightsReserved': 'Visas tiesības aizsargātas',
    'footer.legal-information': 'Juridiskā informācija',
    'footer.show-support-chat-button': 'Atbalsta dienests',
    // Refferal Links
    'page.ref-links.title': 'Manas saites',
    'page.ref-links.description.line-1': 'Zemāk ir norādītas Jūsu personificētās saites uz pirkumu lapām, vietnēm un tml.',
    'page.ref-links.description.line-2': 'Cilvēku kontakti, kuri ir apmeklējuši šis saites un ir atstājuši savu kontaktinformāciju, nonāk žurnālā. Kopējiet tās un sūtiet cilvēkiem.',
    'page.ref-links.table-title.name': 'Nosaukums',
    'page.ref-links.table-title.link': 'Saite',
    'page.ref-links.table-title.copying': 'Kopēšana',
    'page.ref-links.table-action.copy': 'Kopēt',
    'page.ref-links.copy.success': 'Saite ir nokopēta',
    'page.ref-links.copy.error': 'Nav izdevies nokopēt saiti, lūdzu, nokopējiet to manuāli',
    // News
    'page.news.title': 'Jaunumi',
    'page.news.go-to-list': 'Pie jaunumu saraksta',
    'page.news.published': 'Publicēts',
    'page.news.other-news': 'Citi jaunumi',
    'page.news.no-news-yet': 'Pagaidām nav ziņu',
    // Dashboard
    'page.dashboard.ancestors.title': 'Informācija par mentoru',
    'page.dashboard.ancestors.nodata': 'Mentora nav',
    'page.dashboard.ancestors.showAll': 'Parādīt visus',
    'page.dashboard.ancestors.all': 'Visi mentori',
    'page.dashboard.ancestors.modal.table.level': 'Līmenis',
    'page.dashboard.ancestors.modal.table.login': 'Lietotājvārds',
    'page.dashboard.ancestors.modal.table.name': 'Vārds',
    'page.dashboard.ancestors.modal.table.contacts': 'Kontakti',
    'page.dashboard.goal.title': 'Jūsu mērķis uz {date}',
    'page.dashboard.goal.not-set': 'Šajā mēnesim mērķis nav izvirzīts',
    'page.dashboard.goal.set-goal': 'Izvirzīt mērķi',
    'page.dashboard.goal.income.current-result': 'Jūs jau nopelnījāt',
    'page.dashboard.goal.qualification.current-result.required-personal-sales': 'Personīgās pārdošanas:{currentValue} no {required}',
    'page.dashboard.goal.qualification.current-result.required-income': 'Ienākumi no 2.līdz 5.līmenim: {currentValue} no {required}',
    'page.dashboard.goal.get-qualification': 'Iegūt statusu "{expQualification}"',
    'page.dashboard.goal.business-performance': 'Biznesa rādītāji',
    'page.dashboard.goal.more-details': 'Vairāk',
    'page.dashboard.goal.income-details.get-qualification': 'Iegūt statusu ""',
    'page.dashboard.goal.income-details.goal-get-income': 'Mērķis: ienākumi {expAmount} ₽',
    'page.dashboard.finance-events.title': 'Finanšu darbības',
    'page.dashboard.finance-events.show-all': 'Parādīt visas',
    'page.dashboard.finance-events.eventByRemittance-pretext': 'partnerim',
    'page.dashboard.finance-events.eventByReceipt-pretext': 'no',
    'page.dashboard.finance-events.eventByPayment-pretext': 'par',
    'page.dashboard.sales.title': 'Pārdošanas',
    'page.dashboard.sales.show-details': 'Rādīt detaļas',
    'page.dashboard.sales.from': 'no',
    'page.dashboard.sales.placeholder.no-sales': 'Jūsu struktūrā vēl nav bijušas pārdošanas',
    'page.dashboard.sales.placeholder.explore-marketing-plan': 'Iepazīties ar Partneru programmu',
    'page.dashboard.news.title': 'Jaunumi',
    'page.dashboard.news.empty': 'Jaunumu pagaidām nav',
    'page.dashboard.news.show-all': 'Parādīt visas',
    // Roadmap
    'roadmap.title': 'Attīstības plāns',
    // FinanceEvents
    'finance-events.eventByRemittance': 'Izejošais pārskaitījums',
    'finance-events.eventByReceipt': 'Ienākošais pārskaitījums',
    'finance-events.eventByPayment': 'Maksājums',
    'finance-events.eventByWithdrawal': 'Līdzekļu izņemšana',
    'finance-events.eventByPayout': 'Komisijas naudas izmaksa',
    'finance-events.eventByGift': 'Produkta apmaksa partnerim',
    // FINANCE
    'page.finance.title': 'Finanses',
    'page.finance.eventByPayment-pretext': 'par',
    'page.finance.eventByRemittance-pretext': 'partnerim',
    'page.finance.eventByReceipt-pretext': 'no',
    'page.finance.filter.from': 'Laiks no',
    'page.finance.filter.to': 'Laiks līdz',
    'page.finance.filter.type': 'Operācijas veids',
    'page.finance.filter.reset': 'Atcelšana filtru',
    'page.finance.new-remittance.title': 'Pārskaitījums',
    'page.finance.new-remittance.destination-user': 'Saņēmējs',
    'page.finance.new-remittance.type-destination-user-login': 'Ierakstiet saņēmēja lietotājvārdu',
    'page.finance.new-remittance.success-message': 'Pieprasījums naudas līdzekļu pārskaitījumam nosūtīts veiksmīgi',
    'page.finance.new-remittance.note': 'Piezīme',
    'page.finance.new-remittance.available-amount': 'Pārskaitījumam ir pieejami',
    'page.finance.new-remittance.submit': 'Nosūtīt',
    'page.finance.new-remittance.confirm-text': 'Jūs gribat veikt pārskaitījumu:',
    'page.finance.new-remittance.ok-button': 'Apstiprinu',
    'page.finance.new-remittance.cancel-button': 'Atcelt',
    'page.finance.new-remittance.amount': 'Summa',
    'page.finance.new-remittance.submit-button': 'Iesniegt pārskaitījumu',
    'page.finance.new-remittance.alert.line-1': 'Pārskaitījuma apstiprinājums var ilgt līdz pat 24 stundām.',
    'page.finance.new-remittance.alert.line-2': 'Ja pārskaitījums netika apstiprināts šajā laikā, lūdzu vērsieties atbalsta dienestā.',
    'page.finance.new-remittance.alert.line-3': '',
    'page.finance.new-withdrawal.title': 'Līdzekļu izņemšana',
    'page.finance.new-withdrawal.success-message': 'Pieprasījums līdzekļu izņemšanai sekmīgi nosūtīts',
    'page.finance.new-withdrawal.withdrawal-type': 'Līdzekļu izņemšanas veids',
    'page.finance.new-withdrawal.note.placeholder.default': 'Piezīme',
    'page.finance.new-withdrawal.note.placeholder.withdrawal-type-1': 'Jūsu tālruņa numurs',
    'page.finance.new-withdrawal.note.placeholder.withdrawal-type-2': 'Pilns vārds un tālruņa numurs',
    'page.finance.new-withdrawal.amount': 'Summa',
    'page.finance.new-withdrawal.available-amount': 'Izņemšanai pieejami',
    'page.finance.new-withdrawal.next': 'Tālāk',
    'page.finance.new-withdrawal.confirm-text': 'Jūs gribat\nveikt līdzekļu izņemšanu',
    'page.finance.new-withdrawal.confirm.commisiion-warning': 'No norādītās summas\ntiks ieturēta komisija 4%',
    'page.finance.new-withdrawal.confirm-button': 'Apstiprinu',
    'page.finance.new-withdrawal.cancel-button': 'Atcelt',
    'page.finance.new-withdrawal.agreement': 'lvWithdrawalAgreement', // dont translate it
    'page.finance.new-withdrawal.agreement-description': 'Pirms iesnieguma aizpildīšanas vajadzīgs iepazīties un piekrist līdzekļu izņemšanas nosacījumiem.',
    'page.finance.new-withdrawal.exchange-rates-link-title': 'Iepazīstieties ar ECB šī brīža valūtu kursu',
    'page.finance.new-withdrawal.i-agree': 'Es piekrītu līdzekļu izņemšanas nosacījumiem',
    'page.finance.new-withdrawal.balance-limit-error': 'Izņemamā summa pārsniedz pieļaujamo limitu',
    'page.finance.new-withdrawal.max-limit-error': 'Maksimālā summa līdzekļu izņemšanai - {value}',
    'page.finance.new-withdrawal.min-limit-error': 'Minimālā summa līdzekļu izņemšanai - {value}',
    'page.finance.new-withdrawal.go-next': 'Tālāk',
    'page.finance.new-withdrawal.note': 'Papildus informācija',
    'page.finance.new-withdrawal.note.withdrawal-type-1': 'Lai ieskaitītu līdzekļus uz Jūsu bankas karti ir vajadzīgi tās rekvizīti.\nLūdzu aizpildiet datus un atgriezieties uz šo lapu.',
    'page.finance.new-withdrawal.note.withdrawal-type-1-button-caption': 'Aizpildīt',
    'page.finance.new-withdrawal.note.withdrawal-type-2': 'Juridiskām personām, lai izņemtu līdzekļus, vajadzīgs iesniegt dokumentus un bankas rekvizītus pa pastu {email}',
    'page.finance.new-withdrawal.to-bank-card': 'Uz bankas karti',
    'page.finance.new-withdrawal.to-checking-account': 'Uz norēķinu kontu',
    'page.finance.new-withdrawal.no-cards-placeholder': 'Jūs vēl neesat pievienojis nevienu karti',
    'page.finance.new-withdrawal.add-new-card': 'Pievienot karti',
    'page.finance.new-withdrawal.add-new-card.prevention': 'Jūsu kartes dati  tiks ievadīti īpašā&nbsp;maksājuma pakalpojumu logā.<br /><br />Dati saglabājas kompānijā <a href="https://ecommpay.com/" target="_blank">ECOMMPAY</a> un drši glabājās atbilstoši drošības standartiem PCI DSS.<br /><br />Mums nebūs tiešas piekļuves Jūsu&nbsp;bankas kartes rekvizītiem.',
    'page.finance.new-withdrawal.add-new-card.input-card-data': 'Ierakstīt kartes datus',
    'page.finance.new-withdrawal.add-new-card.cancel': 'Atcelt',
    'page.finance.new-withdrawal.add-new-card.success': 'Karte sekmīgi pievienota',
    'page.finance.details.eventByRemittance-pretext': 'Partnerim ',
    'page.finance.details.EventByReceipt-pretext': 'No partnera ',
    'page.finance.details.commissions-details': 'Komisijas maksājumu specifikācija',
    'page.finance.details.commissions-details-button-caption': 'Apskatīt',
    'page.finance.details.note': 'Komentārs',
    'page.finance.details.partner': 'Partneris',
    'page.finance.details.date': 'Finansu operācijas datums',
    'page.finance.details.state': 'Pašreizējais status',
    'page.finance.details.id': 'Operācijas ID',
    'page.finance.event.status.waiting': 'Gaidīšanā',
    'page.finance.event.status.approved': 'Izpildīts',
    'page.finance.event.status.rejected': 'Noraidīts',
    'page.finance.event.status.canceled': 'Atcelts',
    'page.finance.details.withdrawal-state-history.title': 'Statusa izmaiņu vēsture',
    'page.finance.details.withdrawal-state-history.date': 'Datums',
    'page.finance.details.withdrawal-state-history.status': 'Status',
    'page.finance.details.withdrawal-state-history.reason': 'Komentārs',
    'page.finance.details.withdrawal-state-history.reason-not-set': 'Nav norādīts',
    'page.finance.details.withdrawal-state-history.empty': 'Vēsture tukša',
    // Partners
    'page.partners.table.title.level': 'Līmenis',
    'page.partners.table.title.partner': 'Partneris',
    'page.partners.table.title.qualification': 'Kvalifikācija',
    'page.partners.table.title.first-line-income': 'Pirmās līnijas ienākums',
    'page.partners.table.title.total-income': 'Kopējais ienākums',
    'page.partners.table.title.goal': 'Mērķis',
    'page.partners.table.title.no-goal': 'Nav mērķa',
    'page.partners.table.title.goal.income': 'Iegūt ienākumus {expAmount}',
    'page.partners.table.title.goal.qualification': 'Iegūt statusu "{expQualification}"',
    'page.partners.table.title.updated': 'Atjaunots',
    'page.partners.table.title.details': 'Vairāk',
    'page.partners.table.title.show-details': 'Rādīt detaļas',
    'page.partners.table.title.load-more': 'Parādīt vēl',
    'page.partners.filter.period': 'Norādīt periodu',
    'page.partners.filter.active-period': 'Aktīvajā periodā',
    'page.partners.filter.qualifications': 'Status',
    'page.partners.filter.search': 'Meklēt',
    'page.partners.filter.search-placeholder': 'Ierakstiet lietotājvārdu, tālruņa numuru vai e-pastu',
    'page.partners.filter.level': 'Līmeņi',
    'page.partners.filter.all-goals': 'Visi mērķi',
    'page.partners.filter.goal-by-income': 'Ienākumu mērķis',
    'page.partners.filter.goal-by-qualification': 'Kvalifikācijas mērķis',
    'page.partners.filter.all': 'Visi',
    'page.partners.filter.favorite': 'Izvēlētie',
    'page.partners.filter.new': 'Jaunie',
    'page.partners.filter.hide-innactive': 'Paslēpt neaktīvos',
    'page.partners.filter.hide-innactive-tip': 'Noslēpt partnerus, kuri nav izvirzījuši mērķi vai nesaņem ienākumus izvēlētajā laika periodā',
    'page.partners.filter.reset': 'Atiestatīt filtru',
    'page.partners.details.title': 'Biznesa rādītāji',
    'page.partners.details.remove-from-favorites': 'Noņemt no izlases',
    'page.partners.details.add-to-favorites': 'Pievienot izlasei',
    'page.partners.details.show-mentors': 'Parādīt mentorus',
    'page.partners.details.state.unverified': 'Nav verificēts',
    'page.partners.details.state.active': 'Verificēts',
    'page.partners.details.state.blocked': 'Neaktīvs',
    'page.partners.details.in-business-since': 'Master Kit ir nopirkts',
    'page.partners.details.no-goal': 'Nav mērķa',
    'page.partners.details.goal-income': 'Mērķis: ienākumi {amount}',
    'page.partners.details.goal-qualification': 'Iegūt statusu "{expQualification}"',
    'page.partners.details.set-period': 'Norādīt periodu',
    'page.partners.details.personal-sales': 'Personīgās pārdošanas',
    'page.partners.details.personal-sales-description': 'Pārdošanu skaits ar Jūsu novirzīšanas saiti noteiktajā periodā',
    'page.partners.details.personal-sales-left': 'Nepieciešams veikt vēl {personalSalesLeft, plural, one {# personīgo pārdošanu} other {# personīgās pārdošanas}} bāzes komplektu pārdošanu',
    'page.partners.details.out-of': 'no',
    'page.partners.details.income-second-to-fifth-level': 'Ienākumi no 2. līdz 5.līmenim',
    'page.partners.details.income-second-to-fifth-level-description': 'Ienākums, saņemtais no pārdošanām no otrā līdz piektajam līmenim norādītajā periodā',
    'page.partners.details.income-second-to-fifth-level-left': 'Nepieciešamais ienākums {value} no 2. līdz 5.līnijai',
    // 'page.partners.details.strong-branch-income': 'Ienākums no stiprā zara',
    // 'page.partners.details.strong-branch-income-description': 'Kas ir «stiprais zars?»',
    // 'page.partners.details.strong-branch-income-hint': 'Доход должен быть менее 50% от дохода со 2-5 уровень',
    'page.partners.details.approved-qualification': 'Apliecinātais status',
    'page.partners.details.approved-qualification-description': 'Apliecinātais status perioda sākumā',
    'page.partners.details.income': 'Kopējais ienākums',
    'page.partners.details.income-description': 'Ienākums no visas struktūras noteiktajā periodā',
    'page.partners.details.show-income-details': 'Rādīt detaļas',
    'page.partners.details.first-line-income': 'Ienākums no 1. līnijas',
    'page.partners.details.first-line-income-desc': 'Ienākums no 1. līnijas pārdošanām noteiktajā periodā',
    'page.partners.details.second-to-fifth-level-income': 'Ienākums no 2. līdz 5. līnijai',
    'page.partners.details.second-to-fifth-level-income-desc': 'Ienākums, saņemtais no pārdošanām no otrās līdz piektajai līnijai norādītajā periodā',
    'page.partners.details.personale-sales': 'Personīgās pārdošanas',
    'page.partners.details.personale-sales-desc': 'Bāzes komplektu skaits, pārdotais noteiktajā laika periodā',
    'page.partners.details.strong-branch-income-amount': 'Ienākums no stiprā zara',
    'page.partners.details.strong-branch-income-amount-desc': 'Ienākums, saņemtais no pārdošanām stiprajā zarā noteiktajā laika periodā',
    'page.partners.details.personal-turnover': 'Personīgais apjoms',
    'page.partners.details.personal-turnover-desc': 'Kopējais pārdošanas punktu skaits pirmajā līnijā norādītajā laika periodā',
    'page.partners.details.group-turnover': 'Grupas apjoms',
    'page.partners.details.group-turnover-desc': 'Kopējais pārdošanas punktu apjoms visā struktūrā norādītajā laika periodā',
    'page.partners.details.income-from-strong-branch': 'Ienākumi no stipra zars',
    'page.partners.actions.leftContacts': 'Atstāja kontakta informāciju',
    'page.partners.actions.meeting': 'Tikšanās',
    'page.partners.actions.call': 'Zvans',
    'page.partners.actions.downloadedBook': 'Lejuplādēja grāmatu',
    'page.partners.actions.registeredOnSite': 'Reģistrācija vietnē',
    'page.partners.actions.boughtProduct': 'Nopirka produktu',
    'page.partners.actions.becamePartner': 'Kļuva par partneri',
    'page.partners.actions.other': 'Cits',
    // Journal
    'page.journal.tabs.contacts': 'Kontakti',
    'page.journal.tabs.tasks': 'Uzdevumi',
    'page.journal.tabs.favorites': 'Izvēlētie',
    'page.journal.tabs.archive': 'Arhīvs',
    'page.journal.table.updated-at': 'Pieskāriena datums',
    // deprecated
    'page.journal.table.lastActivity': 'Aktivitāte',
    'page.journal.table.time': 'Laiks',
    'page.journal.table.contact': 'Kontakts',
    'page.journal.table.phone': 'Tālrunis',
    'page.journal.table.is-shared': 'Kontakts saņemts no Jūsu partnera',
    'page.journal.add-new.add-contact': 'Pievienot kontaktu',
    'page.journal.add-new.contact-adding': 'Kontakta pievienošana',
    'page.journal.add-new.error': 'Kļūda kontakta pievienošanā',
    'page.journal.add-new.required-field-message': 'Lūdzu, aizpildiet aili',
    'page.journal.add-new.type-name': 'Ierakstiet vārdu',
    'page.journal.add-new.incorrect-email-message': 'Ierakstiet pareizo e-pasta adresi',
    'page.journal.add-new.type-email': 'Ievadiet e-pasta adresi',
    'page.journal.add-new.type-phone': 'Ierakstiet tālruņa numuru',
    'page.journal.add-new.type-note': 'Pievienot komentāru',
    'page.journal.group-actions.title': 'Darbības ar atzīmētajiem',
    'page.journal.group-actions.archive.restore': 'Atjaunot no arhīva',
    'page.journal.group-actions.archive.move-to-archive': 'Pievienot arhīvam',
    'page.journal.group-actions.favorites.remove': 'Noņemt no izlases',
    'page.journal.group-actions.favorites.add': 'Pievienot izlasei',
    'page.journal.group-actions.change-owner.send': 'Nodot parnerim',
    'page.journal.group-actions.reset-selection': 'Atcelt atzīmes',
    'page.journal.group-actions.favorites.remove.confirm': 'Vai Jūs tiešām vēlaties noņemt no izlases  {count, plural, one {# kontakts} other {# kontaktus}}?',
    'page.journal.group-actions.favorites.add.confirm': 'Vai Jūs tiešām vēlaties pievienot izlasei {count, plural, one {# kontaktu} other {# kontaktus}}?',
    'page.journal.group-actions.favorites.remove.success-message': '{count, plural, one {# kontakts sekmīgi noņemts} other {# kontakti sekmīgi noņemti}} no izlases',
    'page.journal.group-actions.favorites.add.success-message': '{count, plural, one {# kontakts sekmīgi pievienots} other {# kontakti sekmīgi pievienoti}} izlasei',
    'page.journal.group-actions.favorites.submit': 'Jā',
    'page.journal.group-actions.favorites.cancel': 'Atcelt',
    'page.journal.group-actions.archive.restored.success-message': '{count, plural, one {# kontakts sekmīgi atjaunots} other {# kontakti sekmīgi atjaunoti}} no arhīva',
    'page.journal.group-actions.archive.archived.success-message': '{count, plural, one {# kontakts sekmīgi nosūtīs} other {# kontakti sekmīgi nosūtīti}} uz arhīvu',
    'page.journal.group-actions.archive.restore.confirm': 'Vai Jūs tiešām vēlaties atjaunot {count, plural, one {# kontaktu} other {# kontaktus}} no arhīva?',
    'page.journal.group-actions.archive.archive.confirm': 'Vai Jūs tiešām vēlaties nosūtīt {count, plural, one {# kontaktu} other {# kontaktus}} uz arhīvu?',
    'page.journal.group-actions.archive.submit': 'Jā',
    'page.journal.group-actions.archive.cancel': 'Atcelt',
    'page.journal.group-actions.change-owner.no-forward-shared-text': 'Starp izvēlētajiem kontaktiem ie tie, kuri bija nodoti Jums no Jūsu partneriem. Šādi kontakti nav pieejami tālākai nodošanai',
    'page.journal.group-actions.change-owner.description': 'Kam nodot {count, plural, one {# kontaktu} other {# kontaktus}}?',
    'page.journal.group-actions.change-owner.success': '{count, plural, one {# kontakts sekmīgi nodots} other {# kontakti sekmīgi nodoti}} partnerim {name}',
    'page.journal.group-actions.change-owner.partner': 'Partneris',
    'page.journal.group-actions.change-owner.placeholder': 'Ierakstiet partnera lietotājvārdu',
    'page.journal.group-actions.change-owner.send-button': 'Nodot',
    'page.journal.group-actions.change-owner.confirm-text': 'Jūs gatavojaties nodot {count, plural, one {# kontaktu} other {#kontaktus}}\npartnerim {name}.\n{count, plural, one {Kontakts tiks izdzēsts} other {Kontakti tiks izdzēsti}} no Jūsu žurnāla.\nVai apstipriniet darbību?',
    'page.journal.group-actions.change-owner.cancel': 'Atcelt',
    'page.journal.group-actions.change-owner.i-confirm': 'Apstiprinu',
    'page.journal.details.actions.title': 'Kontakta darbības',
    'page.journal.details.actions.today': 'šodien',
    'page.journal.details.actions.yesterday': 'vakar',
    'page.journal.details.actions.created-by-you': 'Jūs pievienojāt',
    'page.journal.details.actions.new-action.error': 'Notikusi kļūda pievienojot pieskārienu',
    'page.journal.details.actions.new-action.description': 'Apraksts',
    'page.journal.details.actions.new-action.action-type': 'Pieskāriena veids',
    'page.journal.details.actions.new-action.save': 'Saglabāt',
    'page.journal.details.actions.new-action.cancel': 'Atcelt',
    'page.journal.details.actions.new-action.new-action': 'Jauns pieskāriens',
    'page.journal.details.actions.new-action.add-action': 'Pievienot pieskārienu',
    'page.journal.details.edit.error': 'Notikusi kļūda rediģējot',
    'page.journal.details.edit.name': 'Vārds',
    'page.journal.details.edit.phone': 'Tālrunis',
    'page.journal.details.edit.note': 'Piezīme',
    'page.journal.details.edit.submit': 'Saglabāt',
    'page.journal.details.edit.cancel': 'Atcelt',
    'page.journal.details.edit.title': 'Rediģēt',
    'page.journal.details.tags.tag-name': 'Zīmes nosaukums',
    'page.journal.details.tags.submit': 'Pievienot',
    'page.journal.details.tags.cancel': 'Atcelt',
    'page.journal.details.tags.add-tag': 'Pievienot zīmi',
    'page.journal.details.tasks.title': 'Mani uzdevumi',
    'page.journal.details.tasks.yesterday': 'vakar',
    'page.journal.details.tasks.today': 'šodien',
    'page.journal.details.tasks.tomorrow': 'rīt',
    'page.journal.details.new-task.error': 'Notikusi kļūda pievienojot uzdevumus',
    'page.journal.details.new-task.deadline': 'Termiņš',
    'page.journal.details.new-task.task-name': 'Uzdevums',
    'page.journal.details.new-task.description': 'Apraksts',
    'page.journal.details.new-task.submit': 'Saglabāt',
    'page.journal.details.new-task.cancel': 'Atcelt',
    'page.journal.details.new-task.create': 'Jauns uzdevums',
    'page.journal.details.task.result': 'Kāds ir rezultāts?',
    'page.journal.details.task.finish': 'Pabeigt',
    'page.journal.details.task.cancel': 'Atcelt',
    'page.journal.details.remove-from-favorites': 'Noņemt no izlases',
    'page.journal.details.add-to-favorites': 'Pievienot izlasei',
    'page.journal.details.remove-from-archive': 'Atgriezt no arhīva',
    'page.journal.details.add-to-archive': 'Aizvākt uz arhīvu',
    'page.journal.details.contact-duplication-warning': 'Uzmanību, šis kontakts atrodas arī citu partneru žurnālā!',
    'page.journal.details.give-product.success-message': 'Aktivizācijas pieteikums tiek apstrādāts. Lūdzu uzgaidiet dažas minūtes.',
    'page.journal.details.give-product.error-message': 'Nosūtot pieteikumu notika kļūda. Lūdzu vēršaties atbalsta dienestā',
    'page.journal.details.give-product.gift-description': 'Jūs gatavojaties apmaksāt {productName}',
    'page.journal.details.give-product.will-debited': 'Jūsu iekšējais konts tiks debitēts',
    'page.journal.details.give-product.confirm-text': 'Apstipriniet darbību?',
    'page.journal.details.give-product.confirm.yes': 'Jā',
    'page.journal.details.give-product.confirm.cancel': 'Atcelt',
    'page.journal.details.give-product.title': 'Dāvana partnerim',
    'page.journal.details.give-product.give-product': 'Uzdāvināt produktu',
    'page.journal.details.give-product.select-product': 'Izvēlēties produktu',
    'page.journal.details.give-product.give': 'Uzdāvināt',
    'page.journal.details.give-product.not-enough-money': 'Nepietiek līdzekļu Jūsu iekšējā kontā',
    'page.journal.details.give-product.not-enough-money-amount': 'Nepietiekoša summa:',
    'page.journal.details.give-product.select-product.empty': 'Produktu saraksts ir tukšs',
    'page.journal.details.is-shared': 'Kontakts saņemts no partnera {name}',
    'page.journal.filter.search-placeholder': 'Vārds, tālrunis, e-pasts, atzīmes...',
    'page.journal.filter.period-placeholder': 'Norādīt periodu',
    'page.journal.filter.reset': 'Atiestatīt filtru',
    'page.journal.filter.period.primary': 'Galvenie',
    'page.journal.filter.period.favorites': 'Izvēlētie',
    'page.journal.filter.period.archive': 'Arhīvs',
    'page.journal.filter.isBoughtBaseProduct': 'Master Kit ir nopirkts',
    'page.journal.filter.isNotBoughtBaseProduct': 'Master Kit nav iegādāts',
    'page.journal.filter.isNotBoughtBaseProduct.tooltip': 'Rādīt tikai tos, kuri nav nopirkuši Master Kit',
    // 'page.journal.tasks-list.overdue-tasks': 'Просроченные',
    // 'page.journal.tasks-list.today-tasks': 'На сегодня',
    // 'page.journal.tasks-list.tomorrow-tasks': 'На завтра',
    'page.journal.tasks-list.filter.state.finished': 'Pabeigtie',
    'page.journal.tasks-list.filter.state.unfinished': 'Ieplānotie',
    'page.journal.tasks-list.table.deadline': 'Termiņš',
    'page.journal.tasks-list.table.date-time': 'Datums un laiks',
    'page.journal.tasks-list.table.task-title': 'Uzdevums',
    'page.journal.tasks-list.table.task-result': 'Rezultāts',
    'page.journal.tasks-list.table.contact': 'Kontakts',
    'page.journal.utils.today': 'šodien',
    'page.journal.utils.yesterday': 'vakar',
    'page.journal.at': 'uz',
    'page.journal.utils.all-periods': 'Visā laikā',
    'page.journal.utils.added-today': 'Šodien',
    'page.journal.utils.added-last-week': 'Nedēļas laikā',
    'page.journal.utils.added-last-month': 'Mēneša laikā',
    'page.journal.utils.added-last-year': 'Gada laikā',
    'page.journal.contact.new': 'Jauns',
    'page.journal.add-new.error.already-exists': 'Kontakts ar šādu e-pastu vai tālruņa numuru jau ir sistēmā',
    'page.journal.details.change-owner.title': 'Kontakta nodošana partnerim',
    'page.journal.details.change-owner.tooltip-title': 'Nodot kontaktu partnerim',
    'page.journal.details.change-owner.partner.placeholder': 'Partneris',
    'page.journal.details.change-owner.partner.tip': 'Ierakstiet partnera lietotājvārdu',
    'page.journal.details.change-owner.send': 'Nodot',
    'page.journal.details.change-owner.i-confirm': 'Apstiprinu',
    'page.journal.details.change-owner.cancel': 'Atcelt',
    'page.journal.details.change-owner.confirmation-text': 'Jūs gatavojaties nodot kontaktu partnerim {firstname}{firstname}{lastname}\nKontakts tiks izdzēsts no Jūsu žurnāla\nVai apstipriniet darbību?',
    'page.journal.details.change-owner.success-message': 'Kontakts {contactName} sekmīgi nodots partnerim {firstname}{lastname}',
    // photobank
    'page.photobank.description': 'Šeit Jūs varat lejuplādēt profesionālas fotogrāfijas ar Master Kit. Droši lietojiet tās savās ziņās sociālajos tīklos!',
    'page.photobank.download': 'Lejuplādēt',
    // presentations
    'page.files.download': 'Lejuplādēt',
    // videobank
    'page.videobank.description': 'Šeit apkopoti visi Super Ego video materiāli, sākot ar video par Master Kit līdz spilgtām atmiņām ar īpašajiem piedāvājumiem. Dalieties ar draugiem, klientiem un partneriem! Pievērsiet uzmanību, ka saites nav personificētas',
    'page.videobank.action.open': 'Atvērt',
    'page.videobank.action.copy-link': 'Kopēt saiti',
    'page.videobank.action.copy-link.success': 'Saite sekmīgi nokopēta',
    'page.videobank.action.copy-link.error': 'Neizdevās nokopēt saiti',
    // sales report
    'page.sales-report.table.title': 'Produkts',
    'page.sales-report.table.price': 'Cena',
    'page.sales-report.table.count': 'Skaits',
    'page.sales-report.table.comission': 'Punkti',
    'page.sales-report.table.totalAmount': 'Summa',
    // 'page.sales-report.filter.product': 'Produkts',
    'page.sales-report.filter.category': 'Kategorija',
    'page.sales-report.filter.partner': 'Partneris',
    'page.sales-report.filter.partner-placeholder': 'Ierakstiet lietotājvārdu, tālruņa numuru vai e-pastu',
    'page.sales-report.filter.from': 'Datums no',
    'page.sales-report.filter.to': 'Datums līdz',
    'page.sales-report.filter.reset': 'Atiestatīt',
    'page.sales-report.details.table.id': 'ID',
    'page.sales-report.details.table.buyer': 'Pircējs',
    'page.sales-report.details.table.time': 'Apmaksas datums',
    'page.sales-report.details.table.price': 'Cena',
    'page.sales-report.details.table.commission': 'Punkti',
    // 404
    'page.404.title': 'Lapa nav atrasta',
    'page.404.go-home': 'Uz galveno',
    // 403
    'page.403.title': 'Pieeja ir liegta - nav šādu tiesību',
    'page.403.title-short': 'Pieeja ir liegta',
    'page.403.description': 'Šī resursa skatīšanai nav atbilstošo tiesību',
    'page.403.go-home': 'Uz galveno',
    // ERRORS
    'error.no-access-short': 'Pieejas kļūda',
    'error.request-error': 'Kļūda izpildot pieprasījumu',
    'error.no-access': 'Pieejas kļūda. Darbības izpildei nav atbilstošo tiesību',
    'error.internal-server-error': 'Pieprasījuma izpildes laikā notika servera iekšējā  kļūda',
    'error.no-connection': 'Kļūda savienojumā. Pārbaudiet Interneta pieslēgumu.',
    // 'menu.left.profile.business-reputation': 'Biznesa Reputācija',
    // 'menu.left.profile.business-reputation-info-tooltip': 'Informācija par šo rādītāju',
    // business reputation intro
    'page.sales-report.table.total': 'Kopā',
    'page.sales-report.table.showDetails': 'Vairāk',
    'page.business-reputation-intro.title': 'Biznesa Reputācija',
    'page.business-reputation-intro.step-1.title-1': 'Sagaidiet',
    'page.business-reputation-intro.step-1.title-2': 'Biznesa Reputācija!',
    'page.business-reputation-intro.step-1.text': 'Mēs adoptējām Performance Review - sistēmu, kuru izmanto vadošās IT kompānijas\npasaulē savu līdzstrādnieku motivācijas un iesaistes novērtēšanai.\n\nUn tagad mēs ieviešam šo sistēmu mūsu partneru tīklā!',
    'page.business-reputation-intro.step-1.go-next-button': 'Kā tas strādā?',
    'page.business-reputation-intro.step-2.title': 'Kā tas strādā?',
    'page.business-reputation-intro.step-2.text': 'Mēs apkopojam atpakaļsaiti ar anonīmu aptauju palīdzību\npar sadarbību ar Jums no klientiem, mentoriem un Jūsu komandas.\n\nJums savukārt tāpat ir jānovērtē Jūsu mentors un savi komandas biedri.\nSaņemto atpakaļsaiti ar īpašas formulas palīdzību\npārveidosim vērtējumā (vai reitingā) – Biznesa reputācija (BR).\n\nŠis vērtējums tiks atainots Partnera kabinetā augšējā\nkreisajā stūrī, blakus pieejamo līdzekļu informācijai.',
    'page.business-reputation-intro.step-2.go-next-button': 'Ko tas man dod?',
    'page.business-reputation-intro.step-3.title': 'Ko tas man dod?',
    'page.business-reputation-intro.step-3.text': 'Biznesa Reutācijas vērtējums (BR) ļaus saprast,\nkuri no partneriem ir vairāk lijāli biznesam un maksimāli iesaistīti.\n\nJūs saņemsiet atpakaļsaiti par Jūsu "vājām" vietām\nun sapratīsiet, ko Jums ir vērts izstrādāt.\n\nTurpmāk partneriem ar augstāku BR vērtējumu atvērsies jaunas ekskluzīvas iespējas.\n\nUn otrādi, attiecībā uz partneriem ar zemu\nvai negatīvu vērtējumu tiks ieviesti ierobežojumi.',
    'page.business-reputation-intro.step-3.go-next-button': 'Saprotams',
    'page.business-reputation-intro.step-3.show-more-button': 'Vairāk par Biznesa reputāciju',
    'page.business-reputation-intro.step-3.long-text': 'businessReputationDocLv'
};


const cache = createIntlCache()

const intl = createIntl({
  locale: 'lv',
  messages,
  antdData
}, cache)

export default intl;
